import React, { useRef, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { useAppSelector } from './../../../redux/hooks';
import useMediaQuery from '@mui/material/useMediaQuery';
import SidebarItem from './SidebarItem';

const Sidebar: React.FC = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const drawerMinWidth = isMobile ? 70 : 125;
    const drawerWidth = `max(${drawerMinWidth}px, 5vw)`;

    const colors = useAppSelector(state => state.theme.colors);
    const sideBarMenu = useAppSelector(state => state.navigation.sideBarMenu);

    const sidebarRef = useRef<HTMLDivElement>(null);
    const [currentSidebarWidth, setCurrentSidebarWidth] = useState(drawerMinWidth);

    useEffect(() => {
      const updateSidebarWidth = () => {
        if (sidebarRef.current) {
          setCurrentSidebarWidth(sidebarRef.current.offsetWidth);
        }
      };

      updateSidebarWidth();
      window.addEventListener('resize', updateSidebarWidth);

      return () => window.removeEventListener('resize', updateSidebarWidth);
    }, [drawerWidth]);

  return (
    <Drawer
      variant="permanent"
      ref={sidebarRef}
      sx={{
        width: drawerWidth,
        minWidth: drawerMinWidth,
        height: '100vh',
        marginTop: '0',
        flexShrink: 0,
        ['& .MuiDrawer-paper']: {
          width: drawerWidth,
          minWidth: drawerMinWidth,
          height: 'calc(100vh - 5vh)',
          marginTop: '5vh',
          boxSizing: 'border-box',
          backgroundColor: colors?.sidebar,
          color: colors?.highlightedText,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
          position: 'fixed',
          left: 0,
          top: 0,
          overflowX: 'hidden',
        },
      }}
    >
      <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            overflowY: 'auto',
            marginTop: 3,
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            overflowX: 'hidden'
             }}>

      {sideBarMenu?.map((item: any, index: number) => (
        <SidebarItem
          key={item.key}
          item={item}
          index={index}
          sidebarWidth={currentSidebarWidth}
        />
      ))}

      </Box>
    </Drawer>
  );
};

export default Sidebar;